(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stenhof-catalog-product"] && !Shopify.designMode) return;
  try {
    
const initPhotoReviewSwipe = (root = document) => {
  root.querySelectorAll('.sh-photo-reviews-viewport').forEach(viewport => {
    if (viewport.dataset.shReviewsSwipeReady) return;
    const track = viewport.querySelector('.sh-photo-reviews-track');
    const group = track?.querySelector('.sh-photo-reviews-group');
    if (!track || !group) return;
    viewport.dataset.shReviewsSwipeReady = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let phase = 0;
    let frame = 0;
    let lastTime = 0;
    let pointerId = null;
    let lastX = 0;
    const loopWidth = () => group.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    const paint = () => {
      const width = loopWidth();
      if (width > 0) {
        phase = ((phase % width) + width) % width;
        track.style.transform = 'translate3d(' + (-phase) + 'px, 0, 0)';
      }
    };
    const tick = time => {
      if (!mobile.matches) return;
      const width = loopWidth();
      if (lastTime && width > 0 && !reducedMotion.matches) {
        phase += Math.min(time - lastTime, 64) * width / 110000;
      }
      lastTime = time;
      paint();
      frame = requestAnimationFrame(tick);
    };
    const update = () => {
      cancelAnimationFrame(frame);
      lastTime = 0;
      pointerId = null;
      if (mobile.matches) {
        frame = requestAnimationFrame(tick);
      } else {
        track.style.removeProperty('transform');
      }
    };
    mobile.addEventListener('change', update);
    viewport.addEventListener('pointerdown', event => {
      if (!mobile.matches || event.pointerType !== 'touch' || !event.isPrimary) return;
      pointerId = event.pointerId;
      lastX = event.clientX;
      viewport.setPointerCapture(pointerId);
    });
    viewport.addEventListener('pointermove', event => {
      if (event.pointerId !== pointerId) return;
      phase -= event.clientX - lastX;
      lastX = event.clientX;
      paint();
    });
    const finishSwipe = event => {
      if (event.pointerId === pointerId) pointerId = null;
    };
    viewport.addEventListener('pointerup', finishSwipe);
    viewport.addEventListener('pointercancel', finishSwipe);
    update();
  });
};
initPhotoReviewSwipe();
document.addEventListener('shopify:section:load', event => initPhotoReviewSwipe(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stenhof-header"]) return;
  try {
    
(() => {
  const menuButton = document.querySelector('[data-sh-menu-toggle]');
  const navigation = document.getElementById('sh-main-navigation');
  const closeMenu = () => { if (!menuButton || !navigation) return; menuButton.setAttribute('aria-expanded','false'); menuButton.setAttribute('aria-label','Ouvrir le menu'); navigation.classList.remove('is-open'); };
  menuButton?.addEventListener('click', () => { const opening = menuButton.getAttribute('aria-expanded') !== 'true'; menuButton.setAttribute('aria-expanded',String(opening)); menuButton.setAttribute('aria-label',opening ? 'Fermer le menu' : 'Ouvrir le menu'); navigation?.classList.toggle('is-open',opening); });
  navigation?.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
  const drawer = document.querySelector('[data-sh-cart-drawer]');
  const overlay = document.querySelector('[data-sh-cart-overlay]');
  const body = document.querySelector('[data-sh-cart-body]');
  const foot = document.querySelector('[data-sh-cart-foot]');
  const referenceTotal = document.querySelector('[data-sh-cart-reference]');
  const savingRow = document.querySelector('[data-sh-cart-saving-row]');
  const savingTotal = document.querySelector('[data-sh-cart-saving]');
  const buttonTotal = document.querySelector('[data-sh-cart-button-total]');
  if (!drawer || !overlay || !body || !foot) return;
  const money = (amount, currency) => new Intl.NumberFormat('fr-FR',{style:'currency',currency:currency || 'EUR'}).format(amount / 100);
  const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); overlay.hidden = true; document.body.classList.remove('sh-cart-open'); };
  const render = cart => {
    document.querySelectorAll('[data-sh-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    foot.hidden = cart.item_count === 0;
    document.querySelector('[data-sh-cart-total]').textContent = money(cart.total_price, cart.currency);
    buttonTotal.textContent = money(cart.total_price, cart.currency);
    body.replaceChildren();
    if (!cart.items.length) { const empty = document.createElement('p'); empty.className='sh-drawer-empty'; empty.textContent='Votre panier est vide.'; body.append(empty); return; }
    let cartReference = 0;
    cart.items.forEach(item => {
      const lineReference = Math.max(item.original_line_price || 0,item.final_line_price || 0);
      cartReference += lineReference;
      const row=document.createElement('article'); row.className='sh-drawer-item';
      if(item.image){const img=document.createElement('img');img.src=item.image;img.alt=item.product_title;row.append(img);}else{row.append(document.createElement('span'));}
      const copy=document.createElement('div'); const title=document.createElement('h3'); title.textContent=item.product_title; copy.append(title);
      const variant=document.createElement('p'); variant.textContent=item.variant_title || ''; copy.append(variant);
      const qty=document.createElement('div'); qty.className='sh-drawer-qty'; const minus=document.createElement('button'); minus.type='button'; minus.textContent='−'; minus.dataset.key=item.key; minus.dataset.qty=Math.max(0,item.quantity-1); const count=document.createElement('span'); count.textContent=item.quantity; const plus=document.createElement('button'); plus.type='button'; plus.textContent='+'; plus.dataset.key=item.key; plus.dataset.qty=item.quantity+1; qty.append(minus,count,plus); copy.append(qty); row.append(copy);
      const price=document.createElement('strong'); price.className='sh-drawer-price';
      if(lineReference>item.final_line_price){const crossed=document.createElement('del');crossed.textContent=money(lineReference,cart.currency);price.append(crossed);}
      const current=document.createElement('span');current.textContent=money(item.final_line_price,cart.currency);price.append(current);
      if(lineReference>item.final_line_price){const saved=document.createElement('em');saved.textContent=`Vous économisez ${money(lineReference-item.final_line_price,cart.currency)}`;price.append(saved);}
      row.append(price); body.append(row);
    });
    const handles = new Set(cart.items.map(item => item.handle));
    document.querySelectorAll('[data-sh-upsell-card]').forEach(card => { card.hidden = handles.has(card.dataset.shUpsellCard); });
    const savedAmount = Math.max(0,cartReference-cart.total_price);
    referenceTotal.textContent = money(cartReference,cart.currency);
    savingTotal.textContent = money(savedAmount,cart.currency);
    savingRow.hidden = savedAmount === 0;
  };
  const refresh = async () => { const response=await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`,{headers:{Accept:'application/json'}}); const cart=await response.json(); render(cart); return cart; };
  const open = async () => { startReservationTimer(); overlay.hidden=false; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('sh-cart-open'); await refresh(); drawer.querySelector('[data-sh-cart-close]').focus(); };
  window.StenhofCart={open,close,refresh};
  document.addEventListener('click', async event => {
    if(event.target.closest('[data-sh-cart-open]')){event.preventDefault();await open();return;}
    if(event.target.closest('[data-sh-cart-close]') || event.target === overlay){close();return;}
    const upsellButton=event.target.closest('[data-sh-upsell-variant]');
    if(upsellButton){upsellButton.disabled=true;await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(upsellButton.dataset.shUpsellVariant),quantity:1}]})});await refresh();upsellButton.disabled=false;return;}
    const qtyButton=event.target.closest('[data-key][data-qty]'); if(!qtyButton)return;
    qtyButton.disabled=true; await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:qtyButton.dataset.key,quantity:Number(qtyButton.dataset.qty)})}); await refresh();
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){close();closeMenu();}});
  const reservationKey='stenhofCartReservationEndV3';
  let sessionEnd=Number(sessionStorage.getItem(reservationKey)) || 0;
  let reservationInterval;
  const updateSessionTimer = () => {
    const left = sessionEnd ? Math.max(0,Math.floor((sessionEnd-Date.now())/1000)) : 300;
    document.querySelector('[data-sh-cart-minutes]').textContent=String(Math.floor(left/60)).padStart(2,'0');
    document.querySelector('[data-sh-cart-seconds]').textContent=String(left%60).padStart(2,'0');
    const progress=document.querySelector('[data-sh-cart-progress]');
    if(progress){progress.setAttribute('aria-valuenow',String(left));const fill=progress.querySelector('i');if(fill)fill.style.transform=`scaleX(${left/300})`;}
  };
  const startReservationTimer=()=>{
    const now=Date.now();
    if(!sessionEnd || sessionEnd<=now || sessionEnd-now>300000){sessionEnd=now+300000;sessionStorage.setItem(reservationKey,String(sessionEnd));}
    updateSessionTimer();
    if(!reservationInterval)reservationInterval=window.setInterval(updateSessionTimer,1000);
  };
  updateSessionTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stenhof-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.querySelector('[data-stenhof-wheel]');
  if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;
  const seenKey = 'stenhof-wheel-home-seen-v3';
  const pendingKey = 'stenhof-wheel-signup-pending';
  let returning = false;
  try { returning = sessionStorage.getItem(pendingKey) === '1'; } catch (_) {}
  try { if (!returning && localStorage.getItem(seenKey) === '1') return; } catch (_) {}
  const form = dialog.querySelector('.sh-wheel-form');
  const play = dialog.querySelector('[data-wheel-play]');
  dialog.querySelector('[data-wheel-close]')?.addEventListener('click', () => dialog.close());
  form?.addEventListener('submit', () => {
    try { sessionStorage.setItem(pendingKey, '1'); } catch (_) {}
  }, { capture: true });
  if (play) {
    const disc = dialog.querySelector('[data-wheel-disc]');
    const spin = play.querySelector('[data-wheel-spin]');
    const result = play.querySelector('[data-wheel-result]');
    const copy = play.querySelector('[data-wheel-copy]');
    const finish = () => {
      spin.hidden = true;
      result.hidden = false;
    };
    spin?.addEventListener('click', () => {
      if (spin.disabled) return;
      spin.disabled = true;
      disc.classList.add('is-spinning');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
      } else {
        window.setTimeout(finish, 4100);
      }
    });
    copy?.addEventListener('click', async () => {
      const code = result.querySelector('strong')?.textContent?.trim();
      if (!code) return;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          const input = document.createElement('textarea');
          input.value = code;
          dialog.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }
        copy.textContent = copy.dataset.copiedLabel;
      } catch (_) {
        copy.textContent = code;
      }
    });
  }
  window.setTimeout(() => {
    if (dialog.open) return;
    dialog.showModal();
    dialog.focus();
    try { localStorage.setItem(seenKey, '1'); } catch (_) {}
    if (returning) {
      try { sessionStorage.removeItem(pendingKey); } catch (_) {}
    }
  }, 900);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stenhof-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const form = document.getElementById('stenhof-product-form');
  if (!form) return;
  const variants = JSON.parse(document.getElementById('sh-variants-data').textContent || '[]');
  const lidVariants = JSON.parse(document.getElementById('sh-lid-variants-data').textContent || '[]');
  const idInput = document.getElementById('sh-selected-variant');
  const button = document.getElementById('sh-submit');
  const buttonPrice = document.getElementById('sh-button-price');
  const buttonCompare = document.getElementById('sh-button-compare');
  const buttonLabel = document.getElementById('sh-button-label');
  const panRows = [...document.querySelectorAll('[data-sh-pan-row]')];
  const giftIds = document.querySelector('[data-sh-spatula-variant]');
  const message = document.getElementById('sh-form-message');
  const labDialog = document.querySelector('[data-sh-lab-dialog]');
  const gallery = document.querySelector('[data-sh-gallery]');
  const galleryItems = [...(gallery?.querySelectorAll('[data-sh-media-index]') || [])];
  const galleryThumbs = [...document.querySelectorAll('[data-sh-gallery-thumb]')];
  const setActiveThumb = index => galleryThumbs.forEach((thumb, thumbIndex) => { if (thumbIndex === index) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current'); });
  galleryThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => { const target = galleryItems[index]; if (!gallery || !target) return; gallery.scrollTo({left:target.offsetLeft - (galleryItems[0]?.offsetLeft || 0),behavior:'smooth'}); setActiveThumb(index); }));
  let galleryFrame = 0;
  gallery?.addEventListener('scroll', () => { window.cancelAnimationFrame(galleryFrame); galleryFrame = window.requestAnimationFrame(() => { const origin = galleryItems[0]?.offsetLeft || 0; const nearest = galleryItems.reduce((best,item,index) => Math.abs(item.offsetLeft-origin-gallery.scrollLeft) < best.distance ? {index,distance:Math.abs(item.offsetLeft-origin-gallery.scrollLeft)} : best,{index:0,distance:Infinity}); setActiveThumb(nearest.index); }); },{passive:true});
  const offerPrices = {Unité:{price:6990,compare:13980},'Lot de 2':{price:11490,compare:28725},'Lot de 3':{price:15990,compare:53300}};
  const money = cents => new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(cents/100);
  const normalize = value => String(value || '').replace(/Singolo/g, 'Unité').replace(/Set 2/g, 'Lot de 2').replace(/Set 3/g, 'Lot de 3').replace(/Padella/g, 'Poêle').replace(/Crêpiera|Crepiera/g, 'Crêpière').trim().toLowerCase();
  const selected = name => form.querySelector(`input[name="${name}"]:checked`)?.value;
  const quantity = () => selected('sh-bundle') === 'Lot de 3' ? 3 : selected('sh-bundle') === 'Lot de 2' ? 2 : 1;
  const selectedSizes = () => panRows.slice(0,quantity()).map(row => row.querySelector('[data-sh-pan-size]').value);
  const findVariant = () => {
    const bundle = selected('sh-bundle');
    const title = `${bundle} · ${selectedSizes().join(' + ')}`;
    return variants.find(variant => normalize(variant.title) === normalize(title));
  };
  const update = () => {
    document.querySelectorAll('.sh-bundle-card').forEach(card => card.classList.toggle('is-selected', card.querySelector('input').checked));
    const bundle = selected('sh-bundle');
    const activeCard = form.querySelector('.sh-bundle-card.is-selected');
    const panConfig = form.querySelector('[data-sh-pan-config]');
    if (activeCard && panConfig && activeCard.nextElementSibling !== panConfig) activeCard.after(panConfig);
    panRows.forEach((row,index) => { row.hidden = index >= quantity(); });
    const variant = findVariant();
    const prices = offerPrices[bundle];
    const lidCount = panRows.slice(0,quantity()).filter(row => row.querySelector('[data-sh-pan-lid]').checked).length;
    if (variant) idInput.value = variant.id;
    buttonPrice.textContent = money((prices?.price || 0) + lidCount * 2290);
    buttonCompare.textContent = money((prices?.compare || 0) + lidCount * 3817);
    button.disabled = !variant || !variant.available;
    buttonLabel.textContent = button.disabled ? 'BIENTÔT DISPONIBLE' : 'AJOUTER AU PANIER';
    message.textContent = variant ? '' : 'Cette combinaison sera bientôt disponible.';
  };
  form.addEventListener('change', update);
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = findVariant();
    if (!variant || !variant.available) return update();
    button.disabled = true;
    message.textContent = 'Ajout au panier…';
    try {
      const items = [{id:variant.id,quantity:1}];
      panRows.slice(0,quantity()).forEach(row => {
        if (!row.querySelector('[data-sh-pan-lid]').checked) return;
        const size = row.querySelector('[data-sh-pan-size]').value;
        const lid = lidVariants.find(item => normalize(item.title) === normalize(`Unité · ${size}`));
        if (lid?.available) items.push({id:lid.id,quantity:1});
      });
      if (quantity() >= 3 && giftIds?.dataset.shSpatulaVariant) items.push({id:Number(giftIds.dataset.shSpatulaVariant),quantity:1,properties:{'_Regalo Stenhof':'Set da 3'}});
      if (quantity() >= 2 && giftIds?.dataset.shBoardVariant) items.push({id:Number(giftIds.dataset.shBoardVariant),quantity:1,properties:{'_Regalo Stenhof':quantity() >= 3 ? 'Set da 3' : 'Set da 2'}});
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
      if (!response.ok) throw new Error('cart');
      await response.json();
      message.textContent = 'Ajouté au panier.';
      if (window.StenhofCart) await window.StenhofCart.open();
    } catch (error) {
      message.textContent = 'Impossible d’ajouter le produit. Réessayez dans quelques instants.';
    } finally {
      button.disabled = false;
    }
  });
  document.querySelectorAll('[data-countdown-seconds]').forEach(timer => {
    let end = Number(sessionStorage.getItem('stenhofOfferEnd'));
    if (!end || end < Date.now()) { end = Date.now() + Number(timer.dataset.countdownSeconds) * 1000; sessionStorage.setItem('stenhofOfferEnd', String(end)); }
    const tick = () => {
      const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      timer.querySelector('[data-minutes]').textContent = String(Math.floor(left / 60)).padStart(2,'0');
      timer.querySelector('[data-seconds]').textContent = String(left % 60).padStart(2,'0');
    };
    tick(); window.setInterval(tick, 1000);
  });
  document.querySelector('[data-sh-lab-open]')?.addEventListener('click', () => labDialog?.showModal());
  document.querySelector('[data-sh-lab-close]')?.addEventListener('click', () => labDialog?.close());
  labDialog?.addEventListener('click', event => {
    const bounds = labDialog.getBoundingClientRect();
    const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    if (outside) labDialog.close();
  });
  update();
})();
const initPhotoReviewSwipe = (root = document) => {
  root.querySelectorAll('.sh-photo-reviews-viewport').forEach(viewport => {
    if (viewport.dataset.shReviewsSwipeReady) return;
    const track = viewport.querySelector('.sh-photo-reviews-track');
    const group = track?.querySelector('.sh-photo-reviews-group');
    if (!track || !group) return;
    viewport.dataset.shReviewsSwipeReady = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let phase = 0;
    let frame = 0;
    let lastTime = 0;
    let pointerId = null;
    let lastX = 0;
    const loopWidth = () => group.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    const paint = () => {
      const width = loopWidth();
      if (width > 0) {
        phase = ((phase % width) + width) % width;
        track.style.transform = 'translate3d(' + (-phase) + 'px, 0, 0)';
      }
    };
    const tick = time => {
      if (!mobile.matches) return;
      const width = loopWidth();
      if (lastTime && width > 0 && !reducedMotion.matches) {
        phase += Math.min(time - lastTime, 64) * width / 110000;
      }
      lastTime = time;
      paint();
      frame = requestAnimationFrame(tick);
    };
    const update = () => {
      cancelAnimationFrame(frame);
      lastTime = 0;
      pointerId = null;
      if (mobile.matches) {
        frame = requestAnimationFrame(tick);
      } else {
        track.style.removeProperty('transform');
      }
    };
    mobile.addEventListener('change', update);
    viewport.addEventListener('pointerdown', event => {
      if (!mobile.matches || event.pointerType !== 'touch' || !event.isPrimary) return;
      pointerId = event.pointerId;
      lastX = event.clientX;
      viewport.setPointerCapture(pointerId);
    });
    viewport.addEventListener('pointermove', event => {
      if (event.pointerId !== pointerId) return;
      phase -= event.clientX - lastX;
      lastX = event.clientX;
      paint();
    });
    const finishSwipe = event => {
      if (event.pointerId === pointerId) pointerId = null;
    };
    viewport.addEventListener('pointerup', finishSwipe);
    viewport.addEventListener('pointercancel', finishSwipe);
    update();
  });
};
initPhotoReviewSwipe();
document.addEventListener('shopify:section:load', event => initPhotoReviewSwipe(event.target));

  } catch(e) { console.error(e); }
})();
})();
